import { FilterBaseIcon, FilterInUseIcon } from '@tableau/icons/bundle';
import { ButtonType, ButtonWidget, InteractionState, TabStyles } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../../codegen/Localize';

export interface AdvancedFilterPanelToggleButtonProps {
  readonly advancedFilterButtonClickHandler: () => void;
  readonly filtersApplied: boolean;
  readonly filterPanelShown: boolean;
  readonly disabled: boolean;
}

export class AdvancedFilterPanelToggleButton extends React.PureComponent<AdvancedFilterPanelToggleButtonProps> {
  public constructor(props: AdvancedFilterPanelToggleButtonProps) {
    super(props);
  }

  private getButtonTestIdSuffix() {
    return this.props.filtersApplied? '-applied-filters' : '';
  }

  /*
   If you change this getContent logic, you should also change the corresponding code in Link
       (try checking: link-ui/frontend/src/components/layout/FilterPanelToggleButton.tsx)
  */
  private getContent = (state: InteractionState): JSX.Element => {
    // filters should never be active if the filter panel is disabled
    if (this.props.filtersApplied && !state.disabled) {
      return <FilterInUseIcon size={18} style={{ marginTop: 1 }}/>;
    } else {
      return <FilterBaseIcon size={18} style={{ marginTop: 1 }}/>;
    }
  };

  public render(): JSX.Element {
    return (
      <ButtonWidget
        aria-expanded={!!this.props.filterPanelShown}
        disabled={this.props.disabled}
        buttonType={ButtonType.Icon}
        getContent={this.getContent}
        title={Messages.filters()}
        testId={'advanced-filter-panel' + this.getButtonTestIdSuffix()}
        handleClick={this.props.advancedFilterButtonClickHandler}
        style={{
          // Don't want the double 6 pixel margin between filter and view mode buttons
          marginLeft: 0,
          paddingRight: TabStyles.Spacing.DefaultSpace,
          paddingLeft: TabStyles.Spacing.DefaultSpace
        }}
      />
    );
  }
}
